import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut, signInWithEmailAndPassword } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// 🔐 Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyBr0nlH3U-hdewX6EAxud7Sb0QySovBc-o",
  authDomain: "knyhoobih.firebaseapp.com",
  projectId: "knyhoobih",
  storageBucket: "knyhoobih.firebasestorage.app",
  messagingSenderId: "852354240514",
  appId: "1:852354240514:web:ed108602fea8abc0a2d71b",
  measurementId: "G-7FHXLKZBYB"
};

// ❗️Ось спочатку ініціалізація
const app = initializeApp(firebaseConfig);

// 🔐 Авторизація
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export { signInWithPopup, signOut, signInWithEmailAndPassword };

// 🔗 Firestore
export const db = getFirestore(app);



